import { useCallback, useMemo } from "react";
var useTableRows = function (setRowsTable) {
    var setDataRowsTable = useCallback(function (responseCertificates) {
        var rowsTable = responseCertificates.map(function (item) { return ({
            id: item.id,
            title: item.title,
            type: item.type,
            physicalName: item.physicalName,
            quickPrintable: item.quickPrintable,
            tablesMetadata: item.tablesMetadata,
            thumbnails: item.thumbnails,
        }); });
        setRowsTable(rowsTable);
    }, [setRowsTable]);
    return useMemo(function () { return ({
        setDataRowsTable: setDataRowsTable,
    }); }, [setDataRowsTable]);
};
export default useTableRows;
